import React, { useContext, useEffect, useState }                                                                    from "react";
import { Bar }                                                                                                       from "react-chartjs-2";
import { BarElement, CategoryScale, Chart as ChartJS, Legend, LinearScale, Title, Tooltip, ChartData, ChartOptions } from "chart.js";
import { DashCardProps, DashChartProps }                                                                             from "../DashCard";
import { useCentralCalls }                                                                                           from "@src/rest/CentralCalls";
import ChartDataLabels from 'chartjs-plugin-datalabels'; // Import the plugin
import './styles/DashCharts.scss';
// Register the necessary Chart.js components
ChartJS.register(CategoryScale, LinearScale, BarElement, Legend, Title, Tooltip);

interface DashBarChartProps {
    data: any,
    title: string
}

const DashBarChart: React.FC<DashBarChartProps> = ( props ) => {

    const options: ChartOptions<"bar"> = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: true, // Hide legend if there's only one dataset
            },
            title: {
                display: true,
                text: props.title,
            },
        },
    };
    if( !props.data ) return null;
    console.log('from bar...')
    console.log(props.data);
    return (
        <>
            {props.data?.datasets?.length> 0 &&  <Bar data={props.data} options={options} plugins={[ChartDataLabels]} />}
        </>
    );
};

export default DashBarChart;
